/* eslint-disable @typescript-eslint/no-explicit-any */
import { useDispatch } from "react-redux";
import { setJustificationFilter } from "../index";

export const useJustificationFilterActions = () => {
  const dispatch = useDispatch();
  const updateFilter: any = ({ key, value }: { key: string; value: any }) =>
    dispatch(setJustificationFilter({ key, value }));

  return { updateFilter };
};
